<template>
	<div class="speclist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
			<el-tab-pane :label="tab.name" :name="tab.name" v-for="(tab,index) in tabs" :key="index">
				<span slot="label">{{ tab.name }}</span>
				<el-row>
					<el-col :span="17">
						<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
						<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
					</el-col>
					<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
					<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							v-loading="loading"
							ref="trashlistable"
							:tableData="speclist"
							:columns="tab.columns"
							@gridhandle="gridhandle"
							:gridheight="gridheight"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
							:istop="istop"
						></tableui>
					</el-col>
				</el-row>
				<div>
					<el-row>
						<el-col :span="12">
							<span>共 {{ count }} 条数据</span>
						</el-col>
					</el-row>
				</div>
			</el-tab-pane>
			</el-tabs>
		</el-card>
		<addcargospec ref="addcargospec"></addcargospec>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import addcargospec from '@/components/baseinfo/addcargospec.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton,
		addcargospec
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			istop: false,
			searchbox: '',
			speclist: [],
			gridheight: (window.innerHeight * 68) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: 'id',
			tabs: [],
			mode: '商品规格', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			batch: '',
			count: 0,
			divclass: 'speclist',
			activetab:'',
			activeName:'',
			activeTabIndex: 0 ,//激活的选项卡index
			cargotype:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/baselist.scss');
			this.getTabs();
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			var that = this;
			this.$apipost.get.GetTabs({ parentid: 305 }).then(res => {
				if (res.tabs != undefined) {
					if (res.tabs.length > 0) {
						that.tabs = res.tabs;
						that.activeTabIndex = 0;
						that.activeName = that.tabs[that.activeTabIndex].type;
						that.activetab = that.tabs[that.activeTabIndex].name;
						that.GetTabData();
					} else {
						that.getTabs();
					}
				} else {
					that.getTabs();
				}
			});
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
				if(this.activeTabIndex==1)
					this.cargotype='mobile';
				else
					this.cargotype='';
			}
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get
				.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode, sys: '商城系统' })
				.then(res => {
					//console.log('列配置',res);
					that.tabs[that.activeTabIndex].columns = res;
					that.refreshgrid(true);
				});
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.refreshgrid(false);
				}
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = {};
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.speclist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall = false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					mode: this.mode,
					tab: this.tabs[this.activeTabIndex].type,
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					iscount: 1,
					showcol: JSON.stringify(that.tabs[that.activeTabIndex].columns),
					sys: '商城系统'
				};
				this.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.speclist.push(res.data);
						} else {
							that.speclist = res.data;
						}
					} else {
						that.speclist = [];
					}
					this.count = res.count;
					that.tabs[this.activeTabIndex].pagecount = res.pagecount;
				});
			}
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'del') {
				this.DelSpec();
			}
			if (e.event == 'add') {
				if (this.$refs.addcargospec != undefined) this.$refs.addcargospec.init({ title: '新增规格',cargotype:this.cargotype });
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			console.log(e);
			this.checkedrow = [];
			if (e.event == 'del') {
				//彻底删除
				this.checkedrow.push(this.speclist[e.index]);
				this.DelSpec();
			}
			if (e.event == 'edit') {
				//console.log('spec',this.speclist[e.index]);
				if (this.$refs.addcargospec != undefined)
					this.$refs.addcargospec.init({
						id: this.speclist[e.index].id,
						title: '修改规格',
						spec: JSON.parse(this.speclist[e.index].spec),
						spec_name: this.speclist[e.index].spec_name,
						cargotype:this.cargotype
					});
			}
		},
		
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}else{
				this.checkedrow=[];
			}
			this.selectedall = e.selectedall;
		},
		//删除订单方法1/2
		DelSpec() {
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选数据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.DelSpec2();
					})
					.catch(() => {});
			}
		},
		//删除订单方法2/2
		DelSpec2() {
			var that = this;
			var ids='';
			this.checkedrow.forEach(e=>{
				ids+=e.id+',';
			});
			var paraminfo = {
				spec_name:this.searchbox,
				ids:ids,
				cargotype:this.cargotype
			};
			//console.log('删除',JSON.stringify(paraminfo));
			//return false;
			this.$tool.loading('正在删除', this.divclass);
			this.$apipost.post.DelSpce_SC({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('删除成功', 1);
					that.refreshgrid(true);
				} else {
					if (res.message != '') this.$tool.message(res.message, 0);
					else this.$tool.message('删除失败', 0);
				}
			});
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var id = '';
			var isgo = true;
			var search = {
				id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					id += e.id + ',';
				});
				if (id != '') {
					id = id.substring(0, id.length - 1);
					search.id = id; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//重置筛选
		ResetFilterInfo() {
			this.searchbox='';
			this.refreshgrid(true);
		}
	}
};
</script>
